import { DataBaseModelInterface } from '@solcre-org/core';
import { PortCallPdaLineStatuses } from '../enums/port-call-pda-line-status.enum';
import { PortCallPdaLineOvertimeEntryModel } from './port-call-pda-line-overtime-entry.model';

export class PortCallPdaLineModel implements DataBaseModelInterface {
  constructor(
    public id?: any,
    public pdaId?: any,
    public sourceTariffLineId?: any,
    public sortOrder?: number,
    public concept?: string,
    public lineType?: string,
    public rateValue?: string,
    public unitType?: string,
    public vesselProperty?: string,
    public vesselPropertyValue?: string,
    public expenseCategory?: string,
    public operationDirection?: string,
    public cargoTypeId?: any,
    public cargoTypeName?: string,
    public cargoQuantity?: number,
    public cargoMatchStatus?: string,
    public cargoOperationCount?: number,
    public cargoMeasureType?: string,
    public cargoMeasureValue?: string | number | null,
    public cargoWeightMt?: string | number | null,
    public cargoCubicMeters?: string | number | null,
    public previousSubtotalUsd?: string,
    public formula?: string,
    public inputs?: Record<string, any>,
    public calculatedAmountUsd?: string,
    public previousEffectiveAmountUsd?: string | null,
    public manualAmountUsd?: string | null,
    public isAmountOverridden: boolean = false,
    public effectiveAmountUsd?: string,
    public overrideReason?: string | null,
    public overriddenById?: any,
    public overriddenAt?: string | null,
    public status?: PortCallPdaLineStatuses | string,
    public overtimeBreakdown: PortCallPdaLineOvertimeEntryModel[] = [],
    public overtimeReason?: string | null
  ) {}

  public fromJSON(json: any): PortCallPdaLineModel {
    if (json) {
      this.id = json.id;
      this.pdaId = json.pdaId;
      this.sourceTariffLineId = json.sourceTariffLineId;
      this.sortOrder = Number(json.sortOrder ?? 0);
      this.concept = json.concept;
      this.lineType = json.lineType;
      this.rateValue = json.rateValue;
      this.unitType = json.unitType;
      this.vesselProperty = json.vesselProperty;
      this.vesselPropertyValue = json.vesselPropertyValue;
      this.expenseCategory = json.expenseCategory;
      this.operationDirection = json.operationDirection;
      this.cargoTypeId = json.cargoTypeId;
      this.cargoTypeName = json.cargoTypeName;
      this.cargoQuantity = json.cargoQuantity;
      this.cargoMatchStatus = json.cargoMatchStatus;
      this.cargoOperationCount = json.cargoOperationCount;
      this.cargoMeasureType = json.cargoMeasureType;
      this.cargoMeasureValue = json.cargoMeasureValue ?? null;
      this.cargoWeightMt = json.cargoWeightMt ?? null;
      this.cargoCubicMeters = json.cargoCubicMeters ?? null;
      this.previousSubtotalUsd = json.previousSubtotalUsd;
      this.formula = json.formula;
      this.inputs = json.inputs;
      this.calculatedAmountUsd = json.calculatedAmountUsd;
      this.previousEffectiveAmountUsd = json.previousEffectiveAmountUsd ?? null;
      this.manualAmountUsd = json.manualAmountUsd ?? null;
      this.isAmountOverridden = json.isAmountOverridden ?? false;
      this.effectiveAmountUsd = json.effectiveAmountUsd;
      this.overrideReason = json.overrideReason ?? null;
      this.overriddenById = json.overriddenById ?? null;
      this.overriddenAt = json.overriddenAt ?? null;
      this.status = json.status;
      this.overtimeBreakdown = Array.isArray(json.overtimeApplications)
        ? new PortCallPdaLineOvertimeEntryModel().fromJSONList(json.overtimeApplications)
        : [];
      this.overtimeReason = json.overtimeReason ?? null;
    }
    return this;
  }

  public fromJSONList(json: any): PortCallPdaLineModel[] {
    if (json) {
      return json.map((element: any) => new PortCallPdaLineModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      pdaId: this.pdaId,
      sourceTariffLineId: this.sourceTariffLineId,
      sortOrder: this.sortOrder,
      concept: this.concept,
      lineType: this.lineType,
      rateValue: this.rateValue,
      unitType: this.unitType,
      vesselProperty: this.vesselProperty,
      vesselPropertyValue: this.vesselPropertyValue,
      formula: this.formula,
      calculatedAmountUsd: this.calculatedAmountUsd,
      manualAmountUsd: this.manualAmountUsd,
      isAmountOverridden: this.isAmountOverridden,
      effectiveAmountUsd: this.effectiveAmountUsd,
      overrideReason: this.overrideReason,
      status: this.status,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.concept ?? this.id ?? '';
  }
}
